<style>
.showPerfil {
  cursor: pointer;
  border-bottom: 1px dotted;
}
</style>

<template>
  <div id="page-usuarios">
    <div>
      <v-breadcrumbs :items="breadcrumbs">
        <v-icon slot="divider">forward</v-icon>
      </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12>
          <base-material-card
            color="primary"
            icon="library_books"
            title="Reglas Expediente Manifestación"
            class="elevation-1 px-5 py-3"
          >
            <v-card-actions>
              <v-spacer></v-spacer>
              <exportar-excel
                :data="datos"
                :exportFields="encabezadosExcel"
                name="ReglasExpedienteManifestacion.xlsx"
              >
                <v-btn
                  fab
                  dark
                  x-small
                  color="green"
                  title="Exportar a Excel"
                  v-tippy
                >
                  <v-icon dark>mdi-table</v-icon>
                </v-btn>
              </exportar-excel>
              &nbsp;
              <v-btn
                fab
                dark
                x-small
                color="secondary"
                slot="activator"
                @click.native="
                  model = model_inicial;
                  openModal(1);
                "
                title="Agregar Registro"
                v-tippy
              >
                <v-icon dark>add</v-icon>
              </v-btn>
            </v-card-actions>

            <v-card-text>
              <div id="datagrid">
                <v-client-table
                  ref="vuetable"
                  :data="datos"
                  :columns="columns"
                  :options="options"
                  class="elevation-2 pa-2"
                >
                  <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info"
                      >No se encontró ningún registro</v-alert
                    >
                  </template>
                  <template slot="tipo_documento" slot-scope="props">
                    <div style="display:flex; justify-content:left;">
                      {{
                        props.row.tipo_documento
                          ? props.row.tipo_documento.substring(0, 30)
                          : ""
                      }}
                    </div>
                  </template>
                  <template slot="actions" slot-scope="props">
                    <v-speed-dial
                      v-model="fab[props.row.id]"
                      direction="left"
                      open-on-hover
                    >
                      <template v-slot:activator>
                        <v-btn x-small fab dark color="primary">
                          <v-icon v-if="fab[props.row.id]">mdi-close</v-icon>
                          <v-icon v-else>reorder</v-icon>
                        </v-btn>
                      </template>
                      <v-btn
                        x-small
                        fab
                        dark
                        color="blue"
                        @click.native="getConfigurable(props.row.id)"
                        title="Editar Registro"
                        v-tippy
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn
                        x-small
                        fab
                        dark
                        color="pink"
                        @click.native="eliminar(props.row.id)"
                        title="Eliminar Registro"
                        v-tippy
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-speed-dial>
                  </template>
                </v-client-table>
              </div>
            </v-card-text>
          </base-material-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="modal" width="45%" persistent>
      <v-card>
        <v-form ref="form" lazy-validation>
          <v-card-title>
            <v-card class="primary white--text titulomodal">
              <v-icon class="white--text" @click.native="modal = false"
                >cancel</v-icon
              >
              &nbsp;
              <span class="subheading">
                <strong>{{ update ? "Actualizar" : "Nueva" }} Regla</strong>
              </span>
            </v-card>
          </v-card-title>

          <v-card-text>
            <v-container fluid>
              <v-row class="mt-4">
                <v-col cols="12" lg="12">
                  <v-text-field
                    label="Nombre"
                    v-model="model.nombre_regla"
                    :rules="[rules.required]"
                    maxlength="250"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="6">
                  <v-autocomplete
                    dense
                    chips
                    small-chips
                    clearable
                    multiple
                    :items="patentesArr"
                    v-model="model.patente"
                    label="Patente"
                    placeholder="Todas"
                    :hide-no-data="false"
                  />
                </v-col>
                <v-col cols="12" lg="6">
                  <v-autocomplete
                    dense
                    chips
                    small-chips
                    clearable
                    :items="tiposDocumentos.items"
                    :filter="customFilter"
                    v-model="model.prefijo_documento"
                    item-text="clave"
                    item-value="clave"
                    label="Tipo de Documento"
                    placeholder="Seleccione un Tipo de Documento"
                    :rules="[rules.required]"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content v-if="typeof item !== 'object'">
                        <v-list-item-title v-text="item" />
                      </v-list-item-content>
                      <v-list-item-content v-else>
                        <v-list-item-title
                          v-html="item.clave + ' - ' + item.descripcion"
                        />
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-autocomplete
                    dense
                    chips
                    small-chips
                    clearable
                    multiple
                    :items="aduanasArr"
                    v-model="model.aduana"
                    item-text="nombre"
                    item-value="clave"
                    label="Aduana"
                    placeholder="Todas"
                    :hide-no-data="true"
                  />
                </v-col>
                <v-col cols="12" lg="6">
                  <v-autocomplete
                    dense
                    chips
                    small-chips
                    clearable
                    :items="perfiles"
                    v-model="model.perfil"
                    item-text="nombre"
                    item-value="clave"
                    label="Perfil"
                    placeholder="Todos"
                    :hide-no-data="true"
                  />
                </v-col>

                <v-col cols="12" lg="4">
                  <v-text-field
                    label="Inicia con"
                    v-model="model.inicia_con"
                    maxlength="250"
                    :rules="[
                      validatextos(
                        model.inicia_con,
                        model.contiene,
                        model.termina_con
                      )
                    ]"
                  />
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    label="Contiene"
                    v-model="model.contiene"
                    maxlength="250"
                    :rules="[
                      validatextos(
                        model.inicia_con,
                        model.contiene,
                        model.termina_con
                      )
                    ]"
                  />
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    label="Termina con"
                    v-model="model.termina_con"
                    maxlength="250"
                    :rules="[
                      validatextos(
                        model.inicia_con,
                        model.contiene,
                        model.termina_con
                      )
                    ]"
                  />
                </v-col>
                <v-col cols="12" lg="12">
                  <v-text-field
                    v-if="!numericos"
                    label="Extensiones de Archivo"
                    v-model="model.extensiones"
                    maxlength="250"
                    placeholder="Todas"
                  />

                  <v-switch
                    v-model="numericos"
                    color="primary"
                    label="Solo Extensiones Numéricas"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn @click.native="modal = false">
              <v-icon>cancel</v-icon>
              Cancelar
            </v-btn>

            <v-btn
              color="success"
              @click.native="update ? updateConfigurable() : save()"
            >
              <v-icon>done</v-icon>
              {{ update ? "Actualizar" : "Guardar" }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      encabezadosExcel: {
        Nombre: "nombre_regla",
        Patente: "patente",
        Aduana: "aduana",
        Perfil: "perfil",
        "Clave Tipo": "prefijo_documento",
        "Tipo Documento": "tipo_documento",
        Extensión: "extensiones",
        Inicia: "inicia_con",
        Contiene: "contiene",
        Termina: "termina_con"
      },

      id_cliente: "",
      fab: [],
      numericos: false,
      tipo_indicador: "Expediente Manifestación",
      perfiles: [],
      allChecked: false,
      columns: [
        "nombre_regla",
        "patente",
        "aduana",
        "perfil",
        "prefijo_documento",
        "tipo_documento",
        "extensiones",
        "inicia_con",
        "contiene",
        "termina_con",
        "actions"
      ],
      show_loading: true,
      options: {
        filterable: [
          "nombre_regla",
          "nombre_regla",
          "patente",
          "aduana",
          "perfil",
          "prefijo_documento",
          "tipo_documento",
          "extensiones",
          "inicia_con",
          "contiene",
          "termina_con"
        ],
        sortable: [
          "nombre_regla",
          "nombre_regla",
          "patente",
          "aduana",
          "perfil",
          "prefijo_documento",
          "extensiones",
          "inicia_con",
          "contiene",
          "termina_con"
        ],
        headings: {
          nombre_regla: "Nombre",
          patente: "patente",
          aduana: "Aduana",
          perfil: "Perfil",
          prefijo_documento: "Clave Tipo",
          tipo_documento: "Tipo Documento",
          extensiones: "Extensión",
          inicia_con: "Inicia",
          contiene: "Contiene",
          termina_con: "Termina",
          actions: "Operaciones"
        }
      },
      breadcrumbs: [
        {
          text: "Inicio",
          disabled: false,
          to: "/home"
        },
        {
          text: "Utilerías",
          disabled: true,
          href: "/admin"
        },
        {
          text: "Reglas Expediente Manifestación",
          disabled: true,
          href: ""
        }
      ],
      title: "",
      titleModalDetalle: "",
      modal: false,
      modal_detalle: false,
      update: false,
      patentesArr: [],
      aduanasArr: [],
      usuariosArr: [],
      metadatosArr: [],
      tipos: [
        {
          nombre: "Reglas Expediente Manifestación"
        }
      ],
      perfiles: [0],
      model: {
        nombre_regla: "",
        patente: "",
        aduana: "",
        perfil: "",
        prefijo_documento: "",
        extensiones: "",
        inicia_con: "",
        contiene: "",
        termina_con: "",
        rfc: ""
      },
      model_inicial: {
        nombre_regla: "",
        patente: "",
        aduana: "",
        perfil: "",
        prefijo_documento: "",
        extensiones: "",
        inicia_con: "",
        contiene: "",
        termina_con: "",
        rfc: ""
      },
      rules: {
        required: v => !!v || "Este campo es requerido"
      },

      datos: [],
      permisos_perfiles: [],
      permisos: {
        headers: [
          {
            text: "Categoría",
            value: "categoria"
          },
          {
            text: "Permiso",
            value: "nombre"
          }
        ]
      },
      tiposDocumentos: {
        items: [],
        columns: ["id", "clave", "descripcion"],
        options: {
          filterable: ["clave", "descripcion"],
          sortable: ["clave", "descripcion"],
          orderBy: {
            column: "clave",
            ascending: true
          },
          headings: {
            id: "",
            clave: "Clave",
            descripcion: "Descripción",
            actions: "Descargar"
          }
        },
        filtrados: [],
        columnsFiltrados: ["clave", "descripcion"],
        optionsFiltrados: {
          filterable: ["clave", "descripcion"],
          sortable: ["clave", "descripcion"],
          orderBy: {
            column: "clave",
            ascending: true
          },
          headings: {
            clave: "Clave",
            descripcion: "Descripción"
          }
        }
      }
    };
  },
  created: function() {
    this.id_cliente = this.$local_storage.get("id_cliente");
    this.getAduanas();
    this.getPatentes();
    this.getPerfiles();
    this.getTiposDocumentos();
  },

  methods: {
    validatextos: function(ini, contiene, fin) {
      if (ini == "" && contiene == "" && fin == "") {
        return "Debe tener al menos un texto con el que inicia contiene o termina la regla.";
      }
      return true;
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.clave.toLowerCase();
      const textTwo = item.descripcion.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    getNombreTipo: function(val) {
      return val.nombre + " (" + val.prefijo + ")";
    },
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },

    clearOpciones: function() {
      if (this.model.tipo != undefined) {
        if (this.model.tipo == "Expediente") {
          this.model.usuario = "";
          this.model.metadato = "";
        }
      }
    },
    getAduanas: function() {
      var data = {
        rfc: this.$local_storage.get("rfc")
      };
      axios
        .post(this.$hostname + "reportes/get_aduanas/", data)
        .then(response => {
          if (response.data != undefined) {
            this.aduanasArr = response.data;
          }
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener las aduanas.",
            footer: ""
          });
        });
    },
    getPatentes: function() {
      var data = {
        cliente: this.id_cliente
      };
      //PATENTES
      axios
        .post(this.$hostname + "reportes/get_patentes/", {
          rfc: this.$local_storage.get("rfc")
        })
        .then(response => {
          if (response.data != undefined) {
            this.patentesArr = response.data;
          }
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener las patentes.",
            footer: ""
          });
        });
    },
    getTiposDocumentos: function() {
      var data = {
        tabla: 25
      };
      axios
        .post(this.$hostname + "apendices/lista/", data)
        .then(response => {
          if (response.data != undefined) {
            this.tiposDocumentos.items = response.data;
            this.tiposDocumentos.items = this.tiposDocumentos.items.sort(
              function(a, b) {
                return a.clave > b.clave;
              }
            );
            this.cargar();
          }
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los tipos de documento.",
            footer: ""
          });
        });
    },
    getNombreTipoDocumento: function(tipo) {
      var filtro = this.tiposDocumentos.items.filter(function(e) {
        return e.clave == tipo;
      });
      if (filtro.length > 0) return filtro[0].descripcion;
      else return "";
    },
    getPerfiles: function() {
      var datos = {
        sistema: this.$sistema
      };

      axios
        .get(this.$hostname + "perfiles/")
        .then(response => {
          this.perfiles = response.data;
        })
        .catch(error => {
          this.$root.$dialogLoader.hide();
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los perfiles.",
            footer: ""
          });
        });
    },
    openModal: function(type) {
      if (type == 1) {
        this.model = {
          nombre_regla: "",
          patente: "",
          aduana: "",
          perfil: "",
          prefijo_documento: "",
          extensiones: "",
          inicia_con: "",
          contiene: "",
          termina_con: "",
          rfc: ""
        };
        this.update = false;
      } else {
        this.update = true;
      }
      this.modal = true;
    },

    cargar: function() {
      let self = this;
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      let data = {
        rfc: this.$local_storage.get("rfc")
      };
      axios
        .post(
          this.$hostname + "reglas/expediente_manifestacion/listar_reglas/",
          data
        )
        .then(response => {
          this.datos = response.data;
          this.datos.forEach(function(x) {
            x.tipo_documento = self.getNombreTipoDocumento(x.prefijo_documento);
            x.extensiones = x.extensiones
              ? x.extensiones
                  .toString()
                  .replace("[", "")
                  .replace("]", "")
                  .replace(/'/g, "")
              : "";
            x.aduana = x.aduana
              ? x.aduana
                  .toString()
                  .replace("[", "")
                  .replace("]", "")
                  .replace(/'/g, "")
              : "";
            x.patente = x.patente
              ? x.patente
                  .toString()
                  .replace("[", "")
                  .replace("]", "")
                  .replace(/'/g, "")
              : "";
          });

          this.$root.$dialogLoader.hide();
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los registros.",
            footer: ""
          });
          this.$root.$dialogLoader.hide();
        });
    },

    getConfigurable: function(id) {
      this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
      axios
        .get(this.$hostname + "reglas/expediente_manifestacion/" + id + "/")
        .then(response => {
          this.model = response.data;
          this.model.extensiones = eval(this.model.extensiones);
          this.model.patente = eval(this.model.patente);
          this.model.aduana = eval(this.model.aduana);
          this.numericos = false;
          if (this.model.perfil == "TODOS") {
            this.model.perfil = "";
          }
          if (this.model.aduana[0] == "TODOS") {
            this.model.aduana = "";
          }
          if (this.model.patente[0] == "TODOS") {
            this.model.patente = "";
          }
          if (this.model.extensiones[0] == "TODOS") {
            this.model.extensiones = "";
          } else {
            if (this.model.extensiones[0] == "NUM") {
              this.model.extensiones = "";
              this.numericos = true;
            } else {
              this.model.extensiones = this.model.extensiones.toString();
            }
          }
          this.$root.$dialogLoader.hide();
          this.openModal(2);
        })
        .catch(error => {
          this.$root.$dialogLoader.hide();
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el configurable",
            footer: ""
          });
        });
    },
    getPrefijo: function(tipo) {
      var filtro = this.tipos.filter(function(e) {
        return e.tipo == tipo;
      });
      if (filtro.length > 0) return filtro[0].prefijo;
      else return "";
    },
    save: function() {
      if (this.$refs.form.validate()) {
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
        let data = this.model;
        data["rfc"] = this.$local_storage.get("rfc");

        if (this.model.aduana == undefined) {
          this.model.aduana = ["TODOS"];
        }
        if (this.model.patente == undefined) {
          this.model.patente = ["TODOS"];
        }
        if (this.model.aduana.length == 0) {
          this.model.aduana = ["TODOS"];
        }
        if (this.model.patente.length == 0) {
          this.model.patente = ["TODOS"];
        }
        if (this.numericos) this.model.extensiones = ["NUM"];
        else if (this.model.extensiones == "") {
          this.model.extensiones = ["TODOS"];
        } else {
          this.model.extensiones = this.model.extensiones
            .toUpperCase()
            .split(",");
        }

        if (this.model.perfil == undefined || this.model.perfil == "") {
          this.model.perfil = "TODOS";
        }

        axios
          .post(this.$hostname + "reglas/expediente_manifestacion/", data)
          .then(response => {
            this.modal = false;
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El registro se guardó correctamente.",
              footer: ""
            });

            this.cargar();
          })
          .catch(error => {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text:
                "Ocurrió un error al guardar los datos. Favor de comunicarse con soporte.",
              footer: ""
            });
            this.$root.$dialogLoader.hide();
          });
      }
    },
    updateConfigurable: function() {
      if (this.$refs.form.validate()) {
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
        let data = this.model;

        if (this.model.aduana == undefined) {
          this.model.aduana = ["TODOS"];
        }
        if (this.model.patente == undefined) {
          this.model.patente = ["TODOS"];
        }
        if (this.model.aduana.length == 0) {
          this.model.aduana = ["TODOS"];
        }
        if (this.model.patente.length == 0) {
          this.model.patente = ["TODOS"];
        }
        if (this.numericos) this.model.extensiones = ["NUM"];
        else if (this.model.extensiones == "") {
          this.model.extensiones = ["TODOS"];
        } else {
          this.model.extensiones = this.model.extensiones
            .toUpperCase()
            .split(",");
        }

        if (this.model.perfil == undefined || this.model.perfil == "") {
          this.model.perfil = "TODOS";
        }

        axios
          .put(
            this.$hostname +
              "reglas/expediente_manifestacion/" +
              this.model.id +
              "/",
            data
          )
          .then(response => {
            this.modal = false;
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El registro se guardó correctamente.",
              footer: ""
            });
            this.model = this.model_inicial;
            this.cargar();
          })
          .catch(error => {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text:
                "Ocurrió un error al actualizar los datos. Favor de comunicarse con soporte.",
              footer: ""
            });
            this.$root.$dialogLoader.hide();
          });
      }
    },
    eliminar: function(id) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
          axios
            .delete(
              this.$hostname + "reglas/expediente_manifestacion/" + id + "/"
            )
            .then(response => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El registro se eliminó correctamente.",
                footer: ""
              });
              this.cargar();
            })
            .catch(error => {
              this.$root.$dialogLoader.hide();
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text:
                  "Ocurrió un error al eliminar el registro. Favor de comunicarse con soporte.",
                footer: ""
              });
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.elevation-2 >>> #VueTables_th--id {
  width: 10% !important;
}

.elevation-2 >>> #VueTables_th--clave {
  width: 20% !important;
}

.elevation-2 >>> #VueTables_th--descripcion {
  width: 70% !important;
}

.negrita {
  font-weight: bold;
}
</style>
